import type { AnalyticsInstance, AnalyticsPlugin } from "analytics";
import { type PostHogConfig, posthog } from "posthog-js";

export interface PostHogPluginConfig {
  token?: string;
  enabled?: boolean;
  options?: Partial<PostHogConfig>;
}

type Metadata = Record<string, any>;

interface Params {
  payload: {
    event: string;
    userId: string;
    properties: Metadata;
    traits: Metadata;
  };
  config: PostHogPluginConfig;
  instance: AnalyticsInstance;
}

export default function posthogPlugin(config: PostHogPluginConfig): AnalyticsPlugin {
  return {
    name: "posthog",
    config,
    initialize: ({ config }: Params) => {
      if (!config.token) {
        throw new Error("PostHog token is required");
      }

      posthog.init(config.token, {
        ...config.options,
        autocapture: false,
      });
    },
    page: ({ payload }: Params) => {
      posthog.capture("$pageview", payload.properties);
    },
    track: ({ payload }: Params) => {
      posthog.capture(payload.event, payload.properties);
    },
    identify: ({ payload }: Params) => {
      const set = payload.traits.$set ?? payload.traits;
      const setOnce = payload.traits.$set_once ?? {};
      posthog.identify(payload.userId, set, setOnce);
    },
    loaded() {
      return posthog.__loaded;
    },
    reset() {
      posthog.reset();
    },
  };
}
